export default __webpack_public_path__ + "static/media/bridge-top-bg.34c9bcb0.svg";